var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_124_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.09 74.9805C388.781 26.6289 324.551 0 256.234 0C194.656 0 136.07 21.8086 89.707 61.6992L40.1055 12.9609L30.168 181.469L201.469 168.801L152.859 123.773C182.281 100.672 218.43 88.1055 256.234 88.1055C348.727 88.1055 423.977 163.422 423.977 256C423.977 348.578 348.727 423.898 256.234 423.898C213.77 423.898 173.258 407.98 142.156 379.082C111.223 350.332 92.3594 311.395 89.0469 269.438L87.9531 255.621H0L0.949219 271.516C9.01563 406.367 121.148 512 256.234 512C324.551 512 388.781 485.371 437.09 437.02C485.395 388.668 512 324.379 512 256C512 187.621 485.395 123.332 437.09 74.9805Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_124_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.aaca95e7acbabd615eac1636c42e5efe.svg";
export { ForwardRef as ReactComponent };